Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.setValue = setValue;
exports.resetValuesToDefault = resetValuesToDefault;
exports.setInternalValue = setInternalValue;
exports.patchValue = patchValue;
exports.clearValues = clearValues;

var _constants = require('../utils/constants');

var _helper = require('../utils/helper');

var _constants2 = require('../constants');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function setValue(component, value, label, showFilter, URLParams, componentType, category, meta) {
  return function (dispatch, getState) {
    var _getState = getState(),
        urlValues = _getState.urlValues;

    var reference = void 0;

    if ((0, _helper.isEqual)(urlValues[component], value)) {
      reference = 'URL';
    }

    dispatch({
      type: _constants2.SET_VALUE,
      component: component,
      reference: reference,
      value: value,
      label: label,
      showFilter: showFilter,
      URLParams: URLParams,
      componentType: componentType,
      category: category,
      meta: meta
    });
  };
}

function resetValuesToDefault() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        selectedValues = _getState2.selectedValues,
        componentProps = _getState2.props;

    var defaultValues = {};
    var valueToSet = void 0;
    Object.keys(selectedValues).forEach(function (component) {
      if (!componentProps[component] || !componentProps[component].componentType || !componentProps[component].defaultValue) {
        valueToSet = null;
      } else if ([_constants.componentTypes.rangeSlider, _constants.componentTypes.rangeInput, _constants.componentTypes.ratingsFilter, _constants.componentTypes.dateRange].includes(componentProps[component].componentType)) {
        valueToSet = typeof componentProps[component].defaultValue === 'object' ? [componentProps[component].defaultValue.start, componentProps[component].defaultValue.end] : null;
      } else if ([_constants.componentTypes.multiDropdownList, _constants.componentTypes.multiDataList, _constants.componentTypes.multiList, _constants.componentTypes.singleDataList, _constants.componentTypes.singleDropdownList, _constants.componentTypes.singleList, _constants.componentTypes.tagCloud, _constants.componentTypes.toggleButton, _constants.componentTypes.multiDropdownRange, _constants.componentTypes.multiRange, _constants.componentTypes.singleDropdownRange, _constants.componentTypes.singleRange, _constants.componentTypes.dataSearch, _constants.componentTypes.datePicker].includes(componentProps[component].componentType)) {
        valueToSet = componentProps[component].defaultValue;
      } else if ([_constants.componentTypes.categorySearch].includes(componentProps[component].componentType)) {
        valueToSet = componentProps[component].defaultValue ? componentProps[component].defaultValue.term : '';
      }

      if (!(0, _helper.isEqual)(selectedValues[component].value, valueToSet)) {
        defaultValues = _extends({}, defaultValues, _defineProperty({}, component, _extends({}, selectedValues[component], {
          value: valueToSet
        })));
      }

      return true;
    });
    dispatch({
      type: _constants2.RESET_TO_DEFAULT,
      defaultValues: defaultValues
    });
  };
}

function setInternalValue(component, value, componentType, category, meta) {
  return {
    type: _constants2.SET_INTERNAL_VALUE,
    component: component,
    value: value,
    componentType: componentType,
    category: category,
    meta: meta
  };
}

function patchValue(component, payload) {
  return {
    type: _constants2.PATCH_VALUE,
    component: component,
    payload: payload
  };
}

function clearValues() {
  var resetValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: _constants2.CLEAR_VALUES,
    resetValues: resetValues
  };
}